<table class="table" *ngIf="cartData.length">
  <tbody *ngFor="let item of cartData; let i = index">
    <tr>
      <th class="w-100">
        <div class="d-flex justify-content-between mt-4 mb-3">
        <span class="brand-color" (click)="navigateTo(item)">{{item.title + ' ' +item.color}}</span>
        <a role="button" class="remove-item-btn" (click)="manageQty(item, 'remove')"><i class="pi pi-times-circle text-danger"></i></a>
        </div>
      </th>
    </tr>
    <tr class="mt-3 d-flex justify-content-between align-items-center me-md-4">
      <td (click)="navigateTo(item)">
        <div class="item-image-container">
          <img [src]="item.imageUrl" class="itemImg" [alt]="item.title">
        </div>
      </td>
      <td>
        <div class="def-number-input number-input safari_only">
          <button (click)="manageQty(item, 'minus')" class="button minus"><i class="pi pi-minus"></i></button>
          <input class="quantity fw-bold bg-body-tertiary text-body" [(ngModel)]="item.quantity" readonly>
          <button (click)="manageQty(item, 'plus')" class="button plus"><i class="pi pi-plus"></i></button>
        </div>
      </td>
      <td>
        <!--<span class="mb-0 text-decoration-line-through text-gray"><small>{{item.mrp | currency:"INR"}}</small></span>-->
        <p class="fw-bold">{{item.sellingPrice*item.quantity | currency:"INR"}}</p>
        <!--<span class="badge bg-danger" style="padding: 3px !important;">{{calculateDiscount(item)}}</span>-->
      </td>
    </tr>
    <tr *ngIf="item.pendingOrderItemPolicyPlan" class="d-flex align-items-center justify-content-between">
      <td colspan="2" class="fs-md-6 ps-4"> <!-- Span first two columns -->
        {{item.pendingOrderItemPolicyPlan.name}} &nbsp;<span class="text-gray fw-bold"> x{{item.quantity}}</span>
      </td>
      <td class="text-end pe-4">
        <div class="d-flex justify-content-end align-items-center gap-2">
          <strong class="mb-0">{{item.pendingOrderItemPolicyPlan.price*item.quantity | currency:"INR"}}</strong>
          <a role="button" (click)="manageQty(item, 'remove-warranty')">
            <i class="pi pi-times-circle "></i>
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
